import api from './api.js';

class Signup {
    constructor(){
        this.url_signup = 'dealers/signup'
    }

    create(data){
        return api.post(this.url_signup, data);
    }
}

export default new Signup;
